import React from 'react'
import MaterialSymbol from '../material-symbol'

const Assessment = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="assessment" {...props} />
))

Assessment.displayName = 'Assessment'

export default Assessment
